const events = {
    PURCHASE_WIDGET_SDK_TOS: "PurchaseWidgetSDK_TermsOfSale",
    INTERNAL_LINK: "PurchaseWidgetSDK_InternalLink",
    PAYMENT_SUBMIT: "PurchaseWidgetSDK_Submit",
    CARD_FIELD_ERROR: "PurchaseWidgetSDK_CardField",
};

export default events;
